import type { FC } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { DonutChart, LEGEND_POSITIONS } from "@similarweb/pro-logic-components";

import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import {
    DataRowTitle,
    DataTitle,
} from "app/pages/keyword-research/keyword-analysis/pages/keywords-overview/components/datarow/DataRowStyledComponents";

import { SummaryLoader } from "../styledComponents";

import { getConfig } from "./trafficDistributionGraphConfig";
import { LegendComponentWrapper, TrafficMetricContainerStyled } from "./TrafficDistributionStyledComponents";
import type { ITrafficTitleConfig, ITrafficTransformedData } from "./trafficDistributionTypes";
import { getLegendValueFilter } from "./trafficDistributionUtils";

const DONUT_INNER_SIZE = "60%";
const LEGENDS_GRID_DIRECTION = "column";

interface ITrafficDistribution {
    isLoading: boolean;
    graphItems: ITrafficTransformedData[];
    titles: ITrafficTitleConfig;
}

export const TrafficDistribution: FC<ITrafficDistribution> = ({ isLoading, graphItems = [], titles }) => {
    const { translate } = useTranslate();
    const hasNoData = !isLoading && graphItems.every((item) => !item.y);
    return (
        <TrafficMetricContainerStyled isLoading={isLoading}>
            <BoxTitle
                Container={DataRowTitle}
                tooltip={translate(titles.tooltip)}
            >
                <DataTitle>{translate(titles.title)}</DataTitle>
            </BoxTitle>
            {isLoading ? (
                <SummaryLoader />
            ) : (
                <DonutChart
                    data={[{ data: graphItems }]}
                    config={getConfig(hasNoData)}
                    shouldPresentLegend={true}
                    legendsGridDirection={LEGENDS_GRID_DIRECTION}
                    shouldPresentValueAtLegend={true}
                    withoutTooltipsPadding={false}
                    legendPosition={LEGEND_POSITIONS.LEFT}
                    // @ts-expect-error FIXME: Type 'Element' is not assignable to type 'string'
                    legendValueFilter={getLegendValueFilter}
                    innerSize={DONUT_INNER_SIZE}
                    customLegendComponentWrapper={LegendComponentWrapper}
                    legendGraphGap={16}
                    legendsMinWidth={145}
                />
            )}
        </TrafficMetricContainerStyled>
    );
};
